let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1mjYg")).then(() => parcelRequire('lhP7Q'));